import * as React from "react";
import moment from "moment";

import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";

import {useSelector} from "react-redux";

import {dateFormat, prospectPlayerStatus} from "@/utils/constants";
import {fetchPlayerRating} from "@/utils/playerRating";

import "./index.scss";
import {useTranslation} from "react-i18next";

export default function ScoutingPlayerCard(props) {
	const {element, handleDelete, handleUpdate} = props;

	const {t} = useTranslation();
	const seasonId = useSelector((state) => state?.season?.id);

	const status = prospectPlayerStatus(t)?.filter(
		(s) => s.value === element.prospectStatus,
	)?.[0]?.label;

	const [rating, setRating] = React.useState(null);

	React.useEffect(() => {
		let isMounted = true;

		const loadRating = async () => {
			if (!element?.id || !seasonId) {
				return;
			}

			const value = await fetchPlayerRating(element.id, seasonId);
			if (isMounted) {
				setRating(
					value !== null && value !== undefined
						? Number(value.toFixed(2))
						: null,
				);
			}
		};

		loadRating();

		return () => {
			isMounted = false;
		};
	}, [element?.id, seasonId]);

	return (
		<div className="scout-player-card-container">
			{rating !== null && (
				<div className="rating-badge">
					{/* <span className="rating-label">Rtg</span> */}
					<span className="rating-value">{rating}</span>
				</div>
			)}
			<div className="scout-player-card-header">
				<div className="top-left">
					{moment(element.dateOfBirth)?.year() > 1900
						? moment(element.dateOfBirth).format(dateFormat)
						: "---"}
				</div>
				<div className="top-right">
					{handleDelete || handleUpdate ? (
						<div className="card-actions-container">
							{handleUpdate && (
								<div className="action">
									<EditIcon />
								</div>
							)}
							{handleDelete && (
								<Button
									variant={"outlined"}
									onClick={(e) => {
										e.preventDefault();
										e.stopPropagation();

										handleDelete(element.observedId);
									}}
									color={"error"}
									size="small"
								>
									<div className="action-content d-flex align-items-center">
										<CloseIcon />
									</div>
								</Button>
							)}
						</div>
					) : null}
				</div>
			</div>
			<div className="scout-player-card-info">
				<div className="info-title">
					<div>{element.firstName + " " + element.lastName}</div>
				</div>
				<div className="info-subtitle">
					{status ? <div className="status-pill">{status}</div> : "---"}
				</div>
			</div>
			<div className="separator"></div>
			<div className="scout-player-card-other-info">
				<div className="other-info">
					{element.goalkeeper ? "Portiere" : element.primaryRole}
				</div>
			</div>
		</div>
	);
}
